import { PaymentOption } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { PAYMENT_OPTION_ICON, PAYMENT_OPTION_SHORT_LABELS } from '../../../features/Orders/PaymentOptionLabel';

/** Pay before, pay after and invoice, with short labels and icons. */
export const PAYMENT_OPTION_FILTER_OPTIONS: FilterOption<PaymentOption>[] = Object.values(PaymentOption).map(
  (value) => ({ value, label: PAYMENT_OPTION_SHORT_LABELS[value], icon: PAYMENT_OPTION_ICON[value] })
);
